import { StopType } from "types/MultiStop";
import type { ScheduleStopValue } from "@RequestFormV2/defaults/scheduleDefaults";

/**
 * When multistop is disabled, keep only the classic 2-stop shape:
 * first pickup + last delivery. Returns null when no collapse is needed.
 */
export function collapseStopsToClassicTwo(
  stops: ScheduleStopValue[] | undefined | null,
): ScheduleStopValue[] | null {
  if (!stops || stops.length <= 2) return null;

  const firstPickup = stops.find((stop) => stop.stop_type === StopType.PICKUP);
  const lastDelivery = [...stops].reverse().find((stop) => stop.stop_type === StopType.DROPOFF);
  const pickup = firstPickup ?? stops[0];
  const delivery = lastDelivery ?? stops.at(-1);

  if (!pickup || !delivery) return null;

  return [pickup, delivery];
}
